'use client';
import hero from "@/public/assets/images/Hero.png";
import categoryData from "@/public/ecomsaas-assets/cache/category.json";

import Link from "next/link";
import logo from "@/public/assets/images/logo.png";
import { Compass, Mail, MapPin, Menu, MessageCircle, Phone, Target, X } from "lucide-react";
import { useState } from "react";
import Image from "next/image";
import s1 from "@/public/assets/images/s1 (4).png";
import s2 from "@/public/assets/images/s2 (4).png";
import s3 from "@/public/assets/images/s3 (4).png";
import s4 from "@/public/assets/images/s4 (4).png";
import leader from "@/public/assets/images/Leader.png"
import img from "@/public/assets/images/img.png"
import { Award, CheckCircle, Shield, Zap } from "lucide-react";
import Navbar from "@/components/layouts/Navbar";
import Footer from "@/components/layouts/Footer";


export default function About() {
    const [open, setOpen] = useState(false);

    const features1 = [
        {
            icon: Award,
            title: "Expertise up to 800KV UHV systems",
            desc: "Proven capability in designing, executing, and maintaining ultra-high voltage power systems.",
        },
        {
            icon: Zap,
            title: "Power generation, transmission",
            desc: "End-to-end solutions across power generation, transmission, and distribution networks.",
        },
        {
            icon: Shield,
            title: "Safety-focused engineering practices",
            desc: "Engineering solutions built with strict safety standards and regulatory compliance.",
        },
        {
            icon: CheckCircle,
            title: "Reliable and cost-effective execution",
            desc: "Efficient project delivery that balances performance, quality, and cost.",
        },
    ];
    const features2 = [
        {
            icon: Phone,
            title: "Phone",
            desc: "+91 98765 43210",
        },
        {
            icon: MessageCircle,
            title: "Whatsapp",
            desc: "+91 98765 43210",
        },
        {
            icon: Mail,
            title: "E-Mail",
            desc: "info@fpstnj.com",
        },
        {
            icon: MapPin,
            title: "Office",
            desc: "Chennai,Tamil Nadu",
        },
    ];

    return (
        <>

            <Navbar categoryListData={categoryData} />


            <div className="overflow-x-hidden">

                {/* Hero section */}
                <section className="w-full px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-20 flex flex-col items-center justify-center">
                    <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 lg:gap-[140px] items-center justify-center w-full max-w-7xl mx-auto">
                        <div className="flex flex-col items-center lg:items-start gap-6 order-2 lg:order-1 w-full max-w-sm lg:max-w-[470px]">
                            <h1 className="text-[28px] sm:text-[36px] lg:text-[48px] leading-[119%] text-center lg:text-left text-[#101828] w-full">
                                Reliable Electrical, Solar & Automation Solutions
                            </h1>
                            <p className="text-[16px] sm:text-[18px] lg:text-[24px] leading-[150%] text-center lg:text-left text-[#4A5565] w-full">
                                From LV to HV & UHV systems, delivering safe, cost-effective, and modern power solutions.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-3 sm:gap-[16px] items-center justify-center lg:justify-start w-full">
                                <button className="flex items-center justify-center gap-2 w-full sm:w-fit px-[30px] py-[12px] bg-[#1A3A8A] rounded-[10px] text-white text-[16px] hover:bg-[#153072] transition-colors whitespace-nowrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                                    </svg>
                                    Call Now
                                </button>
                                <button className="flex gap-[8px] items-center justify-center w-full sm:w-fit px-[30px] py-[12px] border border-[#1A3A8A] rounded-[10px] text-[#1A3A8A] text-[16px] hover:bg-[#1A3A8A] hover:text-white transition-colors whitespace-nowrap">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M6.58332 16.6667C8.1738 17.4826 10.0034 17.7036 11.7424 17.2898C13.4814 16.8761 15.0155 15.8549 16.0681 14.4102C17.1208 12.9655 17.6228 11.1923 17.4838 9.41015C17.3448 7.62803 16.5738 5.95416 15.3098 4.69018C14.0458 3.4262 12.372 2.65523 10.5899 2.5162C8.80773 2.37717 7.03455 2.87922 5.58984 3.93189C4.14513 4.98456 3.1239 6.51861 2.71018 8.25761C2.29645 9.99661 2.51744 11.8262 3.33332 13.4167L1.66666 18.3334L6.58332 16.6667Z" stroke="#1A3A8A" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Whatsapp Us
                                </button>
                            </div>
                        </div>

                        <Image
                            src={hero}
                            alt="About Jetplus"
                            sizes="(max-width: 768px) 100vw, 456px"
                            width={456}
                            height={406}
                            priority
                            className="order-1 lg:order-2 w-full max-w-xs sm:max-w-sm lg:max-w-[456px] rounded-[10px] mx-auto lg:mx-0"
                        />
                    </div>

                    <div className="mt-12 sm:mt-[80px] w-full">
                        <hr className="w-full max-w-7xl h-2 text-[#A8A8A8] mx-auto" />
                    </div>
                </section>

                {/* Our Services */}
                <section className="max-w-7xl mx-auto w-full mt-12 sm:mt-[64px] pb-[80px] px-3 sm:px-4 lg:px-8">
                    <div className="flex flex-col gap-4 sm:gap-[16px] items-center justify-center text-center py-12 sm:h-[148px]">
                        <p className="text-[32px] sm:text-[40px] font-[600] leading-[150%]">Our Services</p>
                        <p className="text-[#4A5565] text-lg sm:text-[24px] font-[500] leading-[150%] max-w-2xl mx-auto px-3 sm:pl-[24px] sm:pr-[36px]">
                            Comprehensive solutions for electrical systems, security, renewable energy, and smart automation
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-[32px] mt-[64px]">
                        {/* CARD 1 */}
                        <div className="flex flex-col rounded-[16px] shadow-lg overflow-hidden bg-white w-full h-full min-h-[400px]">
                            <div className="relative w-full h-[200px] sm:h-[226px]">
                                <Image src={s1} alt="" fill className="object-cover" />
                            </div>
                            <div className="p-6 sm:p-[24px] flex flex-col gap-[12px] flex-1">
                                <span className="flex-shrink-0">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z" fill="#1A3A8A" />
                                        <path d="M16 26C15.8108 26.0007 15.6252 25.9476 15.465 25.847C15.3047 25.7464 15.1762 25.6024 15.0946 25.4317C15.0129 25.261 14.9813 25.0706 15.0035 24.8827C15.0257 24.6948 15.1008 24.517 15.22 24.37L25.12 14.17C25.1943 14.0843 25.2955 14.0264 25.407 14.0058C25.5185 13.9852 25.6337 14.0031 25.7337 14.0565C25.8337 14.11 25.9126 14.1959 25.9573 14.3001C26.0021 14.4044 26.0101 14.5207 25.98 14.63L24.06 20.65C24.0034 20.8016 23.9844 20.9646 24.0046 21.125C24.0248 21.2855 24.0837 21.4387 24.1761 21.5715C24.2685 21.7042 24.3918 21.8126 24.5353 21.8872C24.6788 21.9618 24.8383 22.0006 25 22H32C32.1892 21.9994 32.3748 22.0525 32.5351 22.1531C32.6953 22.2537 32.8238 22.3977 32.9055 22.5684C32.9871 22.7391 33.0187 22.9295 32.9965 23.1174C32.9743 23.3053 32.8992 23.4831 32.78 23.63L22.88 33.83C22.8057 33.9158 22.7045 33.9737 22.593 33.9943C22.4815 34.0149 22.3663 33.997 22.2663 33.9435C22.1663 33.89 22.0874 33.8041 22.0427 33.6999C21.9979 33.5957 21.9899 33.4794 22.02 33.37L23.94 27.35C23.9966 27.1985 24.0156 27.0355 23.9954 26.875C23.9752 26.7145 23.9163 26.5614 23.8239 26.4286C23.7315 26.2959 23.6082 26.1875 23.4647 26.1129C23.3212 26.0382 23.1618 25.9995 23 26H16Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <p className="text-lg sm:text-[18px] font-semibold">Electrical Systems</p>
                                <p className="text-sm sm:text-[16px] text-gray-600 leading-relaxed">
                                    LV, HV & UHV testing, commissioning, and services
                                </p>
                            </div>
                        </div>

                        {/* CARD 2 */}
                        <div className="flex flex-col rounded-[16px] shadow-lg overflow-hidden bg-white w-full h-full min-h-[400px]">
                            <div className="relative w-full h-[200px] sm:h-[226px]">
                                <Image src={s2} alt="" fill className="object-cover" />
                            </div>
                            <div className="p-6 sm:p-[24px] flex flex-col gap-[12px] flex-1">
                                <span className="flex-shrink-0">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z" fill="#1A3A8A" />
                                        <path d="M26.5 16H21.5L19 19H16C15.4696 19 14.9609 19.2107 14.5858 19.5858C14.2107 19.9609 14 20.4696 14 21V30C14 30.5304 14.2107 31.0391 14.5858 31.4142C14.9609 31.7893 15.4696 32 16 32H32C32.5304 32 33.0391 31.7893 33.4142 31.4142C33.7893 31.0391 34 30.5304 34 30V21C34 20.4696 33.7893 19.9609 33.4142 19.5858C33.0391 19.2107 32.5304 19 32 19H29L26.5 16Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M24 28C25.6569 28 27 26.6569 27 25C27 23.3431 25.6569 22 24 22C22.3431 22 21 23.3431 21 25C21 26.6569 22.3431 28 24 28Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <p className="text-lg sm:text-[18px] font-semibold">CCTV Solutions</p>
                                <p className="text-sm sm:text-[14px] text-gray-600 leading-relaxed flex-1">
                                    Surveillance systems for residential & commercial use
                                </p>
                            </div>
                        </div>

                        {/* CARD 3 */}
                        <div className="flex flex-col rounded-[16px] shadow-lg overflow-hidden bg-white w-full h-full min-h-[400px]">
                            <div className="relative w-full h-[200px] sm:h-[226px]">
                                <Image src={s3} alt="" fill className="object-cover" />
                            </div>
                            <div className="p-6 sm:p-[24px] flex flex-col gap-[12px] flex-1">
                                <span className="flex-shrink-0">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z" fill="#1A3A8A" />
                                        <path d="M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M24 14V16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M24 32V34" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M16.93 16.9301L18.34 18.3401" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M29.66 29.66L31.07 31.07" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14 24H16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M32 24H34" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M18.34 29.66L16.93 31.07" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M31.07 16.9301L29.66 18.3401" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <p className="text-lg sm:text-[18px] font-semibold">Solar Power</p>
                                <p className="text-sm sm:text-[14px] text-gray-600 leading-relaxed flex-1">
                                    Solar installation and energy solutions
                                </p>
                            </div>
                        </div>

                        {/* CARD 4 */}
                        <div className="flex flex-col rounded-[16px] shadow-lg overflow-hidden bg-white w-full h-full min-h-[400px]">
                            <div className="relative w-full h-[200px] sm:h-[226px]">
                                <Image src={s4} alt="" fill className="object-cover" />
                            </div>
                            <div className="p-6 sm:p-[24px] flex flex-col gap-[12px] flex-1">
                                <span className="flex-shrink-0">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z" fill="#1A3A8A" />
                                        <path d="M27 33V25C27 24.7348 26.8946 24.4804 26.7071 24.2929C26.5196 24.1054 26.2652 24 26 24H22C21.7348 24 21.4804 24.1054 21.2929 24.2929C21.1054 24.4804 21 24.7348 21 25V33" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15 22C14.9999 21.709 15.0633 21.4216 15.1858 21.1577C15.3082 20.8938 15.4868 20.6598 15.709 20.472L22.709 14.473C23.07 14.1679 23.5274 14.0005 24 14.0005C24.4726 14.0005 24.93 14.1679 25.291 14.473L32.291 20.472C32.5132 20.6598 32.6918 20.8938 32.8142 21.1577C32.9367 21.4216 33.0001 21.709 33 22V31C33 31.5304 32.7893 32.0391 32.4142 32.4142C32.0391 32.7893 31.5304 33 31 33H17C16.4696 33 15.9609 32.7893 15.5858 32.4142C15.2107 32.0391 15 31.5304 15 31V22Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <p className="text-lg sm:text-[18px] font-semibold">Home Automation</p>
                                <p className="text-sm sm:text-[14px] text-gray-600 leading-relaxed flex-1">
                                    Smart control systems for modern homes
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Why */}
                <section className="bg-[#1c3f94] py-12 sm:py-16 px-3 sm:px-4 lg:px-8">
                    <div className="max-w-7xl mx-auto text-center text-white mt-12 sm:mt-[80px] pb-[80px]">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4">
                            Why Fasica Power Solutions
                        </h2>
                        <p className="mt-3 text-sm sm:text-base text-white/80 max-w-2xl mx-auto">
                            Technical excellence and reliability you can trust
                        </p>

                        <div className="mt-12 sm:mt-[64px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-[32px] px-3 sm:p-[24px]">
                            {features1.map((item, index) => (
                                <div
                                    key={index}
                                    className="bg-white/10 backdrop-blur-md rounded-xl p-6 sm:p-[24px] text-left hover:bg-white/15 transition-all flex flex-col gap-4 h-full min-h-[260px] sm:min-h-[292px]"
                                >
                                    <div className="w-[48px] h-[48px] flex items-center justify-center rounded-md bg-white/20 mb-[16px]">
                                        <item.icon className="w-[24px] h-[24px] text-white" />
                                    </div>
                                    <h3 className="text-lg sm:text-[18px] font-semibold mb-[8px]">
                                        {item.title}
                                    </h3>
                                    <p className="text-sm sm:text-[16px] leading-relaxed text-white/80 flex-1">
                                        {item.desc}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Our Mission and Vision */}
                <section className="bg-white py-12 sm:py-16 px-3 sm:px-4 lg:px-8 mt-[80px] pb-20 sm:pb-[79.73px]">
                    <div className="max-w-5xl mx-auto text-center">
                        <h2 className="text-2xl sm:text-3xl md:text-[40px] font-semibold text-[#0f172a] mb-[16px]">
                            Our Vision & Mission
                        </h2>
                        <p className="mt-3 text-xl sm:text-[24px] text-slate-500 max-w-2xl mx-auto">
                            Guiding Our Purpose and Impact for a Better Tomorrow
                        </p>

                        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                            {/* Vision Card */}
                            <div className="bg-[#EDF0F6] rounded-xl shadow-md overflow-hidden h-auto">

                                <div className="p-6 text-left">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-10 h-10 rounded-md bg-[#1c3f94] flex items-center justify-center flex-shrink-0">
                                            <Compass className="w-5 h-5 text-white" />
                                        </div>
                                        <h3 className="font-semibold text-lg text-[#0f172a]">
                                            Our Vision
                                        </h3>
                                    </div>
                                    <p className="text-sm text-slate-600 leading-relaxed">
                                        To be a trusted provider of high-quality electrical solutions
                                        across LV, HV, and UHV sectors, alongside innovative CCTV,
                                        solar, and home automation services.
                                    </p>
                                </div>
                            </div>

                            {/* Mission Card */}
                            <div className="bg-[#EDF0F6] rounded-xl shadow-md overflow-hidden max-w-sm mx-auto md:max-w-none">
                                <div className="p-6 text-left">
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="w-10 h-10 rounded-md bg-[#1c3f94] flex items-center justify-center flex-shrink-0">
                                            <Target className="w-5 h-5 text-white" />
                                        </div>
                                        <h3 className="font-semibold text-lg text-[#0f172a]">
                                            Our Mission
                                        </h3>
                                    </div>
                                    <p className="text-sm text-slate-600 leading-relaxed">
                                        To deliver safe, reliable, and cost-effective electrical
                                        solutions by adopting advanced technologies and maintaining
                                        the highest quality standards.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Leadership */}
                <section className="bg-white py-12 sm:py-16 px-3 sm:px-4 lg:px-8">
                    <div className="">
                        <hr className="w-full sm:w-[750px] lg:w-[1500px] h-2 text-[#A8A8A8] mx-auto" />
                    </div>
                    <div className="max-w-7xl mx-auto mt-[80px] pb-[80px]">
                        <div className="text-center mb-12">
                            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#0f172a]">
                                Leadership
                            </h2>
                            <p className="mt-3 text-sm sm:text-base text-slate-500 max-w-2xl mx-auto">
                                Led by experienced professionals in power systems and
                                electrical engineering
                            </p>
                        </div>

                        <div className="bg-white rounded-xl shadow-lg overflow-hidden grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 h-auto md:h-[500px] max-w-4xl lg:w-[869px] mx-auto">
                            <div className="relative h-64 md:h-auto order-2 md:order-1">
                                <Image
                                    src={leader}
                                    alt="Leadership"
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="md:col-span-2 flex items-center justify-center p-6 sm:p-8 order-1 md:order-2">
                                <div className="max-w-md w-full">
                                    <p className="text-sm sm:text-base text-slate-600 leading-relaxed mb-6">
                                        Experience in power system generation, transmission, and
                                        distribution, including testing and commissioning up to
                                        800KV UHV systems.
                                    </p>
                                    <h3 className="font-semibold text-xl sm:text-2xl text-[#0f172a] mb-2">
                                        Franklin
                                    </h3>
                                    <p className="text-base sm:text-lg text-[#1c3f94]">
                                        Director – Fasica Power Solutions (OPC) Pvt Ltd.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Get in Touch */}
                <section className="bg-[#1c3f94] py-12 sm:py-16 px-3 sm:px-4 lg:px-8">
                    <div className="max-w-7xl mx-auto text-center text-white mt-12 sm:mt-[64px] pb-12 sm:pb-[64px]">
                        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4">
                            Get in Touch
                        </h2>
                        <p className="mt-3 text-sm sm:text-base text-white/80 max-w-2xl mx-auto mb-12">
                            Comprehensive solutions for electrical systems, security, renewable energy, and smart automation
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-[43px] px-3 sm:p-[24px]">
                            {features2.map((item, index) => (
                                <div
                                    key={index}
                                    className="bg-white/10 backdrop-blur-md rounded-[12px] p-6 text-center hover:bg-white/15 transition-all flex flex-col gap-[8px] items-center justify-center h-full min-h-[140px]"
                                >
                                    <div className="w-12 h-12 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-white mb-4 flex-shrink-0">
                                        <item.icon className="w-5 h-5 text-[#1A3A8A]" />
                                    </div>
                                    <h3 className="text-sm sm:text-base font-semibold mb-2">
                                        {item.title}
                                    </h3>
                                    <p className="text-xs sm:text-sm font-normal leading-relaxed text-[#DBEAFE]">
                                        {item.desc}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <div className="flex md:flex-col sm:flex-row justify-center items-center gap-4 sm:gap-[16px] mt-12">
                            <p className="text-sm sm:text-base">Follow Us</p>
                            <div className="flex gap-4 sm:gap-[16px]">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="hover:scale-110 transition-transform cursor-pointer">
                                    <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white" fill-opacity="0.1" />
                                    <path d="M28.1667 15.6665H19.8334C17.5322 15.6665 15.6667 17.532 15.6667 19.8332V28.1665C15.6667 30.4677 17.5322 32.3332 19.8334 32.3332H28.1667C30.4679 32.3332 32.3334 30.4677 32.3334 28.1665V19.8332C32.3334 17.532 30.4679 15.6665 28.1667 15.6665Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M27.3333 23.4748C27.4362 24.1683 27.3177 24.8766 26.9948 25.4989C26.6719 26.1213 26.1609 26.6259 25.5347 26.9412C24.9084 27.2564 24.1987 27.3661 23.5065 27.2547C22.8143 27.1433 22.1748 26.8165 21.679 26.3207C21.1832 25.825 20.8564 25.1855 20.745 24.4933C20.6336 23.8011 20.7434 23.0913 21.0586 22.4651C21.3738 21.8388 21.8785 21.3279 22.5008 21.005C23.1231 20.682 23.8314 20.5636 24.525 20.6664C25.2324 20.7713 25.8874 21.101 26.3931 21.6067C26.8988 22.1124 27.2284 22.7673 27.3333 23.4748Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M28.5833 19.4165H28.5916" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="hover:scale-110 transition-transform cursor-pointer">
                                    <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" fill="white" fill-opacity="0.1" />
                                    <path d="M29 15.6665H26.5C25.3949 15.6665 24.3351 16.1055 23.5537 16.8869C22.7723 17.6683 22.3333 18.7281 22.3333 19.8332V22.3332H19.8333V25.6665H22.3333V32.3332H25.6666V25.6665H28.1666L29 22.3332H25.6666V19.8332C25.6666 19.6122 25.7544 19.4002 25.9107 19.2439C26.067 19.0876 26.279 18.9998 26.5 18.9998H29V15.6665Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </section>


            </div>

            <Footer />



        </>
    );
}
